import * as React from 'react';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Link} from 'shells/link/link';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceNoun as getPhoneProviderName} from '../calls/helpers';

import {
    getServiceNoun,
    getServiceNounPlural,
    getServiceSupportUrl,
    getUnloggedMeetingsSubtitle,
} from './helpers';
import {ProviderSyncIllustration} from './provider-sync-illustration';
import type {ExternalServiceTypeFrontend} from './tables/types';

type Props = {
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
    hasLoggedMeetings: boolean;
    firstEnabledIntegrationType?: ExternalServiceType | null | undefined;
};

export function FirstLoadUnloggedTableEmptyState(props: Props) {
    const serviceCategoryNounPlural = getServiceNounPlural(props.serviceType);
    const phoneProviderName =
        props.firstEnabledIntegrationType && props.serviceType === 'PHONES'
            ? getPhoneProviderName(props.firstEnabledIntegrationType)
            : null;

    return (
        <EmptyStateLarge
            title={
                props.hasLoggedMeetings
                    ? `No unlogged ${serviceCategoryNounPlural}`
                    : `No ${serviceCategoryNounPlural} found yet`
            }
            subtitle={getUnloggedMeetingsSubtitle(props.serviceType, props.hasLoggedMeetings)}
            detailTextBullets={
                props.serviceType === 'PHONES'
                    ? [
                          phoneProviderName
                              ? `Recorded ${phoneProviderName} calls will sync into Nutshell and appear here as unlogged activities.`
                              : 'Recorded calls will sync into Nutshell and appear here as unlogged activities',
                      ]
                    : [
                          `Enable cloud recording to securely store your meetings on ${getServiceNoun(
                              props.serviceType
                          )} servers`,
                          'Confirm that you have all required recording permissions',
                      ]
            }
            cta={
                <Link
                    variant='button-primary'
                    href={getServiceSupportUrl(
                        props.firstEnabledIntegrationType
                            ? props.firstEnabledIntegrationType
                            : props.serviceType
                    )}
                    newTab={true}
                    size='xlarge'
                >
                    Learn more
                </Link>
            }
            icon={
                <ProviderSyncIllustration
                    serviceType={props.serviceType}
                    firstEnabledIntegrationType={props.firstEnabledIntegrationType}
                />
            }
        />
    );
}
